'use client';

import { useTranslations } from 'next-intl';

import BillingAddressForm from 'components/payment/components/BillingAddressForm';
import usePaymentFormContext from 'hooks/usePaymentFormContext';
import ChoiceInput from 'ui/ChoiceInput';

const AddBillingAddressInformation = () => {
  const { shouldAddBillingAddress, onChangeShouldAddBillingAddress } = usePaymentFormContext();

  const tCheckout = useTranslations('checkout');

  return (
    <div className="mt-4">
      <div className="sm:col-span-6 flex flex-col gap-y-2">
        <ChoiceInput
          id="shouldAddBillingAddress"
          name="shouldAddBillingAddress"
          label={tCheckout('addBillingAddress')}
          checked={shouldAddBillingAddress}
          type="checkbox"
          color="black"
          blurOnDisabled={false}
          labelTextSize="text-base"
          onChange={onChangeShouldAddBillingAddress}
        />
      </div>

      {shouldAddBillingAddress && <BillingAddressForm />}
    </div>
  );
};

export default AddBillingAddressInformation;
